/**
 * 通用流式分帧工具。
 *
 * SSE / NDJSON 这类流式接口的字节流本质是"按分隔符切成多帧"，
 * 每帧再交给各自的 parseFrame 解析成业务事件。
 * 这里把"攒 buffer → 按分隔符切帧 → flush 补最后一段"的公共骨架收拢，
 * 不同接口只需提供分隔符和解析函数，新增流式接口时不用再复制一份 TransformStream。
 */
export function createFrameTransformStream<TEvent>(
  separator: string,
  parseFrame: (frame: string) => TEvent | null
): TransformStream<string, TEvent> {
  let buffer = "";

  return new TransformStream<string, TEvent>({
    transform(chunk, controller) {
      buffer += chunk;
      const frames = buffer.split(separator);
      // 最后一段可能是不完整帧，留到下一块数据或 flush 时再处理
      buffer = frames.pop() ?? "";
      for (const frame of frames) {
        const event = parseFrame(frame);
        if (event) controller.enqueue(event);
      }
    },
    flush(controller) {
      if (buffer.trim()) {
        const event = parseFrame(buffer);
        if (event) controller.enqueue(event);
      }
    },
  });
}
